"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
const legalData = [{
  id: "company",
  label: "Unternehmensname",
  value: "Musterunternehmen GmbH"
}, {
  id: "legal-form",
  label: "Rechtsform",
  value: "Gesellschaft mit beschränkter Haftung"
}, {
  id: "headquarters",
  label: "Sitz der Gesellschaft",
  value: "Musterstadt"
}, {
  id: "register",
  label: "Handelsregister",
  value: "Amtsgericht Musterstadt, HRB 123456"
}, {
  id: "ceo",
  label: "Geschäftsführer",
  value: "Max Mustermann, Erika Mustermann"
}, {
  id: "vat",
  label: "Umsatzsteuer-ID",
  value: "DE 123 456 789"
}, {
  id: "tax",
  label: "Steuernummer",
  value: "123/456/78901"
}, {
  id: "chamber",
  label: "Zuständige Kammer",
  value: "IHK Musterstadt"
}];
export default function LegalInformation() {
  return <section id="rechtliche-angaben" className="bg-background py-16 md:py-24">
      
    </section>;
}